import { render, staticRenderFns } from "./BookingsListTab.vue?vue&type=template&id=0aa03e58&scoped=true&"
import script from "./BookingsListTab.vue?vue&type=script&lang=js&"
export * from "./BookingsListTab.vue?vue&type=script&lang=js&"
import style0 from "./BookingsListTab.vue?vue&type=style&index=0&id=0aa03e58&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa03e58",
  null
  
)

export default component.exports